import { getGuestToken, setGuestToken } from "../Utils/guestToken.js";
import { normalizeCartResponse } from "../Utils/normalizeCartResponse.js";

import axios from "axios";

// Detect platform details
const getPlatformDetails = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile =
    /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(userAgent);

  let platform = "web";
  let deviceName = "Desktop Browser";
  let appVersion = "web-1.0.0";

  if (isMobile) {
    platform = "mobile_web";
    appVersion = "web-mobile-1.0";

    if (userAgent.includes("chrome")) {
      deviceName = "Mobile Chrome Browser";
    } else if (userAgent.includes("safari")) {
      deviceName = "Mobile Safari";
    } else {
      deviceName = "Mobile Browser";
    }
  } else {
    if (userAgent.includes("chrome")) {
      deviceName = "Chrome Browser";
    } else if (userAgent.includes("firefox")) {
      deviceName = "Firefox Browser";
    } else if (userAgent.includes("safari")) {
      deviceName = "Safari Browser";
    }
  }

  const deviceId = `${platform}-${Math.random().toString(36).substring(2, 10)}`;

  return { platform, deviceName, appVersion, deviceId };
};

// Axios instance
const axiosInstance = axios.create({
  // baseURL: "https://uat-api.shopdiy.in/", //prod
  baseURL: "https://api-uat.shopdiy.in/", //dev
  // baseURL: "http://192.168.1.4:1234/", //order againorder again
});

//uat: 15.206.37.249

// live: 15.206.156.98

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Token ${token}`;
    } else {
      const guestToken = getGuestToken();
      if (guestToken) {
        config.headers["X-Guest-Token"] = guestToken;
      }
    }

    // config.headers["domain"] = "192.168.1.4"; // dev-testing
    // config.headers["domain"] = "uat.bgbonline.in"; // dev-testing
    // config.headers["domain"] = "bgbonline.in"; // prod-testing

    // uncomment below line before deploying to production
  
    config.headers["domain"] = window.location.hostname.replace("www.", "");

    // uncomment above line before deploying to production

    const { platform, deviceName, appVersion, deviceId } =
      getPlatformDetails();

    config.headers["Platform"] = platform;
    config.headers["Device-Id"] = deviceId;
    config.headers["Device-Name"] = deviceName;
    config.headers["App-Version"] = appVersion;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Automatically capture backend-issued guest token from response headers
    const newGuestToken =
      response?.headers?.["x-guest-token"] ||
      response?.headers?.["X-Guest-Token"] ||
      response?.data?.guest_token;
    if (newGuestToken) {
      setGuestToken(newGuestToken);
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;

    // Handle Cart Version Conflict (HTTP 409)
    if (status === 409) {
      const errData = error.response?.data;
      const currentVersion = errData?.error?.current_version || errData?.current_version;
      const conflictPayload = errData?.fresh_cart || errData?.cart || errData;
      const normalizedCart = conflictPayload ? normalizeCartResponse(conflictPayload) : null;
      if (normalizedCart && currentVersion) {
        normalizedCart.version = currentVersion;
      }
      const conflictError = new Error("Cart version conflict");
      conflictError.code = "CART_VERSION_CONFLICT";
      conflictError.isCartVersionConflict = true;
      conflictError.status = 409;
      conflictError.currentVersion = currentVersion;
      conflictError.freshCart = normalizedCart;
      conflictError.latestCart = normalizedCart;
      conflictError.response = error.response;
      return Promise.reject(conflictError);
    }

    const isAlreadyLoggedOut = sessionStorage.getItem("logout_done");
    const token = localStorage.getItem("token");
    const isCartEndpoint = error.config?.url?.includes("/accounts/api/cart/");

    if ((status === 401 || status === 403) && !isAlreadyLoggedOut && token && !isCartEndpoint) {
      // 🔥 prevent multiple reloads
      sessionStorage.setItem("logout_done", "true");

      // ✅ remove only your keys
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("number");
      localStorage.removeItem("address_id");
      localStorage.removeItem("traveltime");
      localStorage.removeItem("wishlists");
      localStorage.removeItem("total");
      localStorage.removeItem("orderId");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

